import { wrapCreateBrowserRouterV6 } from '@sentry/react';
import { createBrowserRouter } from 'react-router';

import { env } from '~/lib/config';

/**
 * Wraps the routes with Sentry functionality if VITE_APP_SENTRY_ENABLED is '1'.
 */
export function sentryCreateBrowserRouter(
    routes: Parameters<typeof createBrowserRouter>[0],
    opts?: Parameters<typeof createBrowserRouter>[1],
) {
    if (env.VITE_APP_SENTRY_ENABLED === '1') {
        const sentryWrappedBrowserRouter =
            wrapCreateBrowserRouterV6(createBrowserRouter);

        return sentryWrappedBrowserRouter(routes, opts);
    }

    return createBrowserRouter(routes, opts);
}
